/* A readable enlargement of supplied infographics and photos, including on touch screens. */
(() => {
  const init = () => {
    document.querySelectorAll('img[data-full-src]').forEach((image) => {
      const fallback = () => { image.removeAttribute('srcset'); image.src = image.dataset.fullSrc; };
      image.addEventListener('error', fallback, {once:true});
      if (image.complete && !image.naturalWidth) fallback();
    });
    const figures = [...document.querySelectorAll('.visual.supplied, .product-copy-photo, .product-comparison')];
    if (!figures.length) return;
    const dialog = document.createElement('dialog');
    dialog.className = 'media-lightbox';
    dialog.setAttribute('aria-label', 'Agrandissement du visuel');
    const toolbar = document.createElement('div'); toolbar.className = 'media-lightbox-toolbar';
    const zoom = document.createElement('button'); zoom.type = 'button'; zoom.textContent = 'Agrandir'; zoom.setAttribute('aria-pressed', 'false');
    const close = document.createElement('button'); close.type = 'button'; close.textContent = 'Fermer';
    const scroll = document.createElement('div'); scroll.className = 'media-lightbox-scroll';
    const image = document.createElement('img'); scroll.append(image); toolbar.append(zoom, close); dialog.append(toolbar, scroll); document.body.append(dialog);
    let opener, overflow;
    const resetZoom = () => { dialog.classList.remove('is-zoomed'); zoom.textContent = 'Agrandir'; zoom.setAttribute('aria-pressed', 'false'); scroll.scrollTop = 0; scroll.scrollLeft = 0; };
    zoom.addEventListener('click', () => { const expanded = dialog.classList.toggle('is-zoomed'); zoom.setAttribute('aria-pressed', String(expanded)); zoom.textContent = expanded ? 'Vue complète' : 'Agrandir'; });
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => { document.body.style.overflow = overflow; document.documentElement.classList.remove('media-lightbox-open'); opener?.focus({preventScroll:true}); });
    figures.forEach((figure) => {
      const source = figure.querySelector('img'); if (!source) return;
      figure.classList.add('media-inspectable');
      const button = document.createElement('button'); button.type = 'button'; button.className = 'media-inspect-button'; button.textContent = '⤢'; button.setAttribute('aria-label', `Agrandir : ${source.alt}`);
      button.addEventListener('click', () => { opener = button; overflow = document.body.style.overflow; image.src = source.dataset.fullSrc || source.src; image.alt = source.alt; resetZoom(); document.body.style.overflow = 'hidden'; document.documentElement.classList.add('media-lightbox-open'); dialog.showModal(); close.focus(); });
      figure.append(button);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
})();

/* Warm the next gallery image, then anticipate content as mobile reading starts. */
(() => {
  const gallery = document.querySelector('media-gallery .product__media-list');
  const hero = gallery?.querySelector('img');
  const warmNext = () => {
    const slides = [...gallery.children];
    const active = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    [slides[active], slides[active + 1]].forEach((slide) => {
      const image = slide?.querySelector('img[loading="lazy"]');
      if (!image) return;
      image.fetchPriority = 'low';
      image.loading = 'eager';
    });
  };
  if (hero) {
    if (hero.complete) warmNext();
    else {
      hero.addEventListener('load', warmNext, { once: true });
      hero.addEventListener('error', warmNext, { once: true });
    }
    new MutationObserver(warmNext).observe(gallery, { subtree: true, attributes: true, attributeFilter: ['class'] });
  }
  if (!('IntersectionObserver' in window)) return;
  const mobile = window.matchMedia('(max-width: 749px)').matches;
  const pending = new Set(document.querySelectorAll('.product__description img[loading="lazy"]'));
  let observer;
  const observe = (margin) => {
    observer?.disconnect();
    observer = new IntersectionObserver((entries) => {
      entries.forEach(({ target: image, isIntersecting }) => {
        if (!isIntersecting) return;
        image.fetchPriority = 'auto';
        image.loading = 'eager';
        pending.delete(image);
        observer.unobserve(image);
      });
    }, { rootMargin: margin, threshold: 0 });
    pending.forEach((image) => observer.observe(image));
  };
  observe(mobile ? '400px 0px 600px 0px' : '1500px 0px 3500px 0px');
  if (mobile) window.addEventListener('scroll', () => observe('800px 0px 1800px 0px'), { once: true, passive: true });
})();
